import React from "react";

export const Gallery = (props) => {
  return (
    <div id="portfolio" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Our Clients</h2>
          <p>
           We proudly serve clients acrossdiverse industries, delivering tailored recruitment solutions that meet their unique workforce needs.<br/>Our Leading Clients.
          </p>
        </div>
        <div className="row">
          <div className="portfolio-items">
            {props.data
              ? props.data.map((d, i) => (
                <div
                key={`${d.title}-${i}`}
                className="col-sm-6 col-md-4 col-lg-4 text-center"
              >
                <div
                  style={{
                    width: "200px",
                    height: "200px",
                    margin: "0 auto",
                    borderRadius: "50%",
                    overflow: "hidden",
                    background: "#fff", // white background for logos
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                  }}
                >
                  <img
                    src={d.smallImage}
                    alt={d.title}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain", // keeps full logo visible
                      padding: "10px", // optional padding for breathing space
                    }}
                  />
                </div>
                <h3 className="mt-3">{d.title}</h3>
              </div>
              
                ))
              : "Loading..."}
          </div>
        </div>
      </div>
    </div>
  );
};
